import { useEffect } from 'react';
import { Trans, t } from '@lingui/macro';
import { Button, EmptyState, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { usePlai } from 'app/domains/review';
import { Spacer } from './styled';
const ONE_SECOND = 1000;
const POLL_INTERVAL = 5 * ONE_SECOND;
export function ReviewInProgress() {
    const { reviewing, startPollingReview, stopPollingReview } = usePlai();
    const handleClick = () => {
        // TODO: handle cancelling review
    };
    useEffect(() => {
        if (reviewing) {
            startPollingReview(POLL_INTERVAL);
            return () => {
                stopPollingReview();
            };
        }
        return undefined;
    }, [reviewing, startPollingReview, stopPollingReview]);
    return (<EmptyState title={t({
            message: 'Reading document..',
            comment: 'Plai Drawer - reviewing in progress - loading state - title',
        })} description={t({
            message: 'Your review will be ready in just a moment',
            comment: 'Plai Drawer - reviewing in progress - loading state - description',
        })} icon={<Falcon icon="bolt"/>} withAvatar actions={<Spacer>
          <Loader size={12}/>
          <Button appearance="secondary" size="medium" onClick={handleClick}>
            <Trans comment="Plai Drawer - reviewing in progress - cancel review button label">
              Cancel Review
            </Trans>
          </Button>
        </Spacer>}/>);
}
